import { StationDataTypes } from './station-data.types';

export const setStationDataUrl = stationDataUrl => {
  return {
    "type": StationDataTypes.SET_STATION_DATA_URL,
    "payload": stationDataUrl
  };
};

export const setStationData = stationData => {
  return {
    "type": StationDataTypes.SET_STATION_DATA,
    "payload": stationData
  };
};

export const setFilteredStationData = filteredStationData => {
  return {
    "type": StationDataTypes.SET_FILTERED_STATION_DATA,
    "payload": filteredStationData
  };
};